import * as React from "react";
function SvgPlus(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M48 21H27V0h-6v21H0v6h21v21h6V27h21v-6z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPlus);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
